import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import API from 'configs/API';
import { axiosPost } from 'utils/apis/axios';
import { ToastTopHelper } from 'utils/utils';

const createExhibition = async (formData) => {
  const { data } = await axiosPost(false, API.ARTWORK.EXHIBITION, formData);
  return data;
};

const useCreateExhibition = () => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: createExhibition,
    onSuccess: () => {
      ToastTopHelper.success(t('create_successfully'));
    },
  });
};

export default useCreateExhibition;
